import {customAxiosBE} from "../config";

export async function getDriversAPI({depotId, active} = {}) {
    const params = new URLSearchParams();
    if (depotId) params.append("depotId", depotId);
    if (active !== undefined && active !== null) params.append("active", active);
    const query = params.toString();
    return customAxiosBE.get(`/driver${query ? `?${query}` : ""}`);
}

export async function getDriverByIdAPI(id) {
    return customAxiosBE.get(`/driver/${id}`);
}

export async function insertDriverAPI(payload) {
    return customAxiosBE.post(`/driver`, payload);
}

export async function updateDriverAPI(id, payload) {
    return customAxiosBE.put(`/driver/${id}`, payload);
}

export async function deactivateDriverAPI(id) {
    return customAxiosBE.delete(`/driver/${id}`);
}

export async function getDriverAbsencesAPI(driverId) {
    return customAxiosBE.get(`/driver/${driverId}/absence`);
}

export async function getAbsencesInPeriodAPI({from, to}) {
    const params = new URLSearchParams({from, to});
    return customAxiosBE.get(`/driver/absence?${params.toString()}`);
}

export async function insertDriverAbsenceAPI(payload) {
    return customAxiosBE.post(`/driver/absence`, payload);
}

export async function deleteDriverAbsenceAPI(id) {
    return customAxiosBE.delete(`/driver/absence/${id}`);
}

export async function importDriversAPI(payload) {
    return customAxiosBE.post(`/driver/import`, payload);
}
